import { BookingService } from "../../modules/booking/services/booking-service"

export const findCountryOfCity = async (city) => {
  const countriesData = await BookingService.findCountriesOfCity({
    city
  });

  if (countriesData && countriesData.data.countries && countriesData.data.countries.length > 0) {
    return {
      text: countriesData.data.countries[0].country,
      value: countriesData.data.countries[0].country,
    };
  }
}